import React, { useEffect, useState } from "react";
import numeral from "numeral";
import toastr from "toastr"
import SweetAlert from "react-bootstrap-sweetalert";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Label,
  CardBody,
  Modal,
  ModalHeader,
  ModalBody,
  Table,
  Input,
  InputGroup,
  Button,
} from "reactstrap";
import { Link } from "react-router-dom";
import  { useHistory } from  'react-router-dom'
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import axios from "../../axios"
//Import Product Images
import img1 from "../../assets/images/product/image23432.jpg";
import img2 from "../../assets/images/product/img-2.png";
import img3 from "../../assets/images/product/img-3.png";
import img4 from "../../assets/images/product/img-4.png";
import img5 from "../../assets/images/product/img-5.png";
import img6 from "../../assets/images/product/img-6.png";
import { makeStyles } from '@material-ui/core/styles';
import  Spinner  from 'react-spinkit'
import Backdrop from '@material-ui/core/Backdrop';
import DeleteModal from "../../components/Common/DeleteModal"
import '../../NumberInput.css'
import { set } from "lodash";
const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));
const productListvar = [
  {
    id: 1,
    img: img1,
    name: "Rounded Earrings",
    color: "Maroon",
    price: "450",
    data_attr: 2,
    total: 900,
  },
  
];


const EcommerceCart = (props) => {
  const [productList, setproductList] = useState(productListvar);

  function countUP(id, prev_data_attr) {
    setproductList(
      productList.map((p) =>
        p.id === id ? { ...p, data_attr: prev_data_attr + 1 } : p
      )
    );
  }

  function countDown(id, prev_data_attr) {
    setproductList(
      productList.map((p) =>
        p.id === id ? { ...p, data_attr: prev_data_attr - 1 } : p
      )
    );
  }
  const history = useHistory()
const [allcartproducts, setallcartproducts] = useState([])
const [purchseid, setpurchseid] = useState('')
const [tokent, settokent] = useState('Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJldmVudGxpc3QiOlt7IlVzZXJJRCI6IjEiLCJMb2dpbkNvZGUiOiIwMSIsIkxvZ2luTmFtZSI6IkFkbWluIiwiRW1haWxJZCI6ImFkbWluQGdtYWlsLmNvbSIsIlVzZXJUeXBlIjoiQURNSU4ifV0sImlhdCI6MTYzODM1NDczMX0.ZW6zEHIXTxfT-QWEzS6-GuY7bRupf2Jc_tp4fXIRabQ')
const [Purchasesavess, setPurchasesavess] = useState(false)
const [dailoa1, setdailoa1] = useState(false)
const [allproductslists, setallproductslists] = useState([])
const [qtyval, setqtyval] = useState('1')
const classes = useStyles();
const [pricevalue, setpricevalue] = useState('')
const [modal, setModal] = useState(false)
const [indexalueofupdate, setindexalueofupdate] = useState('')
const [Productonecollect, setProductonecollect] = useState([])
const [sgstper, setsgstper] = useState('')
const [salesrate, setsalesrate] = useState('')
const [proid, setproid] = useState('')
const [vatper, setvatper] = useState('')
const [uomdesc, setuomdesc] = useState('')
const [cgstper, setcgstper] = useState('')
const [taxid, settaxid] = useState('')
const [purchaseqtys, setpurchaseqtys] = useState('1')
const [totalqty, settotalqty] = useState('')
const [TOtaligstamt, setTOtaligstamt] = useState('')
const [deleteModal, setDeleteModal] = useState(false)
const [deletid, setdeletid] = useState('')
const [delteprods, setdelteprods] = useState(false)
const [updatenetamt, setupdatenetamt] = useState('')

const [productnames, setproductnames] = useState('')
const [provalue, setprovalue] = useState([])
const [uomid, setuomid] = useState('')
const [conqty, setconqty] = useState('')
const [discountper, setdiscountper] = useState('')
const [gstper, setgstper] = useState('')
const [sgstid, setsgstid] = useState('')

const [cgstpercentages, setcgstpercentages] = useState('')
const [igstper, setigstper] = useState('')
const [produpdata, setprodupdata] = useState(false)
var imageDefault = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAANlBMVEX///+/v7+8vLzKysr8/Pzg4ODFxcXb29vT09Pj4+P4+PjBwcH6+vry8vLY2NjIyMjs7Ozo6Oia8u11AAAEdUlEQVR4nO2d65bqIAxGp/Smrb34/i971KqlEC7FGuJZ3/7dKewJBgK4/PsDAAAAAAAAAAAAAAAA4KUam5+i3m94UsUPoVoYwlA6MIShfGAIQ/nAEIbyOcBQSeNww9NZGOXBhuq8+w1fxugfDG1gmB0YBoFhdmAYBIbZgWEQGGYHhkFgmB0YBoFhdmAYBIbZyWB4qVI6mgyv4WUeH7u007lL7vFeWA3n8rUFrZqWK5KchnWvPapOTGFkNDQPOJrhk45Hw2d4Ns+oVPlRz2NhMxyawkTtv2OWAJvhSBwzfjBO2+g/5TLs7BDeSF4eDP0Y+yiX4UydFKtT4pRxa3SKTcVchtQgLYrobhq0Kj7+XIb0aX+fZtipHfH/ScPlZZG5Jq9hk2RYP96lTnFPcxnWpGF52d2eNrPGPc5lOJC5NDrl65Sv1fs16nEuw8v20sdCP+9uTh8NZVSuYVvTnKlBmjAdaqu/uH8Qm2FVWuNUJYSwOu3tLV9tcelNw5SF9yZjRaVixvpwbrZRTKnyuyKysRXOGn/QBqpK25QzptVm9598eyfqXDaPnah+GlNmwr/aGOcqYl3DvJtYzXU7jvU1bbVmVdExE+pP7Qjb6TiiOBFmOPuyD7XyC+djWYadGt2KxE5PzMpWluHtXc6KQZ/rNYK5RpThfWXnrGzp6iRcQ0ky7KbHK+iBup3rtQZD6wZJhq+9HDIsri89BBsUZPguIal0Y871K6ECRY6hXkFaimQeXQjVUHIMNwWkuVax5/q1xcC6Rozh0G+7vYmidaqzCaJ/whBjaEZJr608Y7QIHvBIMbR3/dfB55jr3/hrKCGGxMHN+vmi53rtSW+uEWLYUj1/dsY1169tetc1MgwHaw9HU3TN9Svec0huw4os6CZHcO7dcc/163O+XMNteC0JRfdk0Aby6BNfDcW9i1EquzedI4R36vAYLfy5htnwtnBRvaHo/SZxjN8Nz7UO5ltf97WnMgbqHCfhRbmHKa/hdXl2qxjzQQsaunMNr+FzUlD62W8bORD9TM4gshpe3xVg+Z7BonJlmN55mMhpWGkV4GughtacsbgvLnAa6hXga6B666I9OGsoRsPtMbCa7l2q6OVaAs6uMxpejXDdd+SPSTMP+vyGdri6+bAQui8u8BmaIbwxUdcXkg0dNRTjOf6BNiSOGirrXYxjcXQ+632ag6EPE7kMiU/h4dA1FJfhgUnTzZTRkCOEt8apYcpj+P1E6u4+j+H3E+kCdUmKxZAjkS4QrbMY8nwKC7qGYjFkSaQL9rqGw5AthORhIoMhUyJ9ksPwsDI+Brv97xtWY8mJNUwZYtixYu0qyjhd+yYwDALD7MAwCAyzA8MgMMwODIPAMDtHGxZ1JYvjDRvWajCC7SYRfhsBhvKBIQzlA0MYygeGMJQPDGEoHxjCUD4whKF8YAhD+cAQhvKBIQzlA0MYygeGMJQPDGEoHxjCUD4whKF8YAhD+cAQhvJJM/wpEgyv9U+R8iNaAAAAAAAAAAAAAAAAAP4r/gEYCYE2Xwz6DQAAAABJRU5ErkJggg=='
const [prodimage, setprodimage] = useState('')
const [purchasegetone, setpurchasegetone] = useState([])
const [purchsdtlid, setpurchsdtlid] = useState('')
const [igstid, setigstid] = useState('')
const [billraised, setbillraised] = useState('')
const [qtyerror, setqtyerror] = useState(false)
const [purchaseupdatesmessage, setpurchaseupdatesmessage] = useState(false)
useEffect(() => {
  Getallproductslistsss()
    ////////////////console.log(localStorage.getItem('Carts'))
    let cartproducts = []
    let productofcart = JSON.parse(localStorage.getItem('Carts'))
    //cartproducts.push()
setallcartproducts(productofcart)
if (props.match.params.id) {
  Getallsuppliervalue()
}else{
  
}

    }, [])
    

    const Getallproductslistsss = async() => {
      const get= await axios.instance.get('/Getallproducts',{ headers: {'Authorization':tokent,
      'Content-Type': 'application/json',
      
      }}).then((res) => {
        


  setallproductslists(res.data)
      })
      }


const checkoutss = () => {
  setdailoa1(true)
setTimeout(() => {
  history.push('/Purchase-OrderCheckout')
  setdailoa1(false)
}, 3000);
}
const checkoutss1 = () => {
  Updatepurchaseorderhdrs()
  setdailoa1(true)
  setpurchaseupdatesmessage(true)
setTimeout(() => {
  history.push('/My-Purchase-Orders')
  setdailoa1(false)
}, 3000);
}


const onClickDelete = user => {
  setdeletid(user.Product_Details_Id)
  setDeleteModal(true)

}

const Updateget =  async(id, id1)  => {
  //////////////console.log(id, id1)
  setindexalueofupdate(id1)
  setProductonecollect([])
// setvisible(true)
// setVisiblespinner(true)
// setTimeout(() => {
// setVisiblespinner(false)
// }, 2000);
 const datavalue  =  allcartproducts.filter(a => a.Product_Details_Id  === id)
 setProductonecollect(datavalue)
 //////////////console.log('test',datavalue)
 for(const data of datavalue) {
   ////////////console.log('datssss',data.CGSTPer)
setgstper(data.GSTPer)
  setuomid(data.UOM_Id)
   setqtyval(data.Order_Quantity)
 setpricevalue(data.Rate)
 setsgstper(data.SGSTPer)
 setsalesrate(data.Sales_Rate)
 setproid(data.Product_Details_Id)
 setvatper(data.VAT_Percentage)
 setupdatenetamt(data.Amount)
 setproductnames(data.Product_Details_Description)
 setuomdesc(data.UOM_Description)
 setcgstpercentages(data.CST_Percentage)
 settaxid(data.TaxId)
setsgstid(data.SGSTId)
setigstid(data.IGSTId)
setigstper(data.IGSTPer)
setprodimage(data.Imagepath)
 ////////////console.log('updd',data)
 }

}





const updateproduct =  async()  => {
  if(qtyval !=0) {

 
  let product = []
  let productsvalue = localStorage.getItem('Carts')
  
  //////////////////console.log(items)
  // ////////////////console.log(items != null  )
  if( productsvalue != null  ) {
  const getdata = JSON.parse(productsvalue) 
  for(const data of getdata){
 
  product.push(data)
  
  }
  
  }
  ////////////////console.log(parseInt( updatedqty))
  //const totlaamoutns =   localStorage.getItem('Total_Amount')
  //////////////console.log('gstsss',gstper)
 const updateddatevalue = {
  
    Product_Details_Description: productnames,
    Product_Details_Id: proid,
    UOM_Id:uomid,
    Order_Quantity:qtyval,
    Rate: pricevalue,
    CST_Percentage: cgstper === '' ? 0 : cgstper,
    VAT_Percentage: vatper === '' ? 0 : vatper,
    Discount_Percentage: 0,
    RateinAED: 0,
    TaxId: taxid === '' ? 0 : taxid,
    UOMType: 'P',
    DiscAmt: 0,
    ExciseId: 0,
    ExcisePer: 0,
    OtherDesc: '',
    GSTPer: gstper,
    SGSTId: sgstid,
    SGSTPer: sgstper,
    IGSTId: igstid,
    IGSTPer: igstper,
    PriUOM_Id:uomid ,
    PriOrder_Quantity: qtyval,
     PriRate: 0,
    ConQty: qtyval,
    Act_UOM: uomid,
    Act_Rate: 0,
    Act_Qty:qtyval,
    Sec_UomId: uomid,
  UOMtype: "P",
  Imagepath:prodimage
  
   }
     product[indexalueofupdate]  =  updateddatevalue
  //////////////console.log('check',indexalueofupdate)
 localStorage.setItem('Carts',  JSON.stringify(product))
  let Getprod =  localStorage.getItem('Carts')
  // setprovalue(Getprod)
  const getdelteddate =  localStorage.getItem('Carts')
  let removeproducts = JSON.parse(getdelteddate)
  // localStorage.setItem('cartlength',getdelteddate)
  ////////////////console.log(removeproducts)
  setallcartproducts(removeproducts)
  let qtytotal = []
  
  for(const data of removeproducts){
  qtytotal.push(parseFloat(data.Order_Quantity))
  }
  var qtyvalue = 0 
  for (let i = 0; i < qtytotal.length; i++) {
    qtyvalue += qtytotal[i];
  }
  settotalqty(qtyvalue)
  localStorage.setItem('TotalQty',qtyvalue)
  
  let taxtotal = []
  for(const data of removeproducts) {
  taxtotal.push(parseFloat(data.GSTPer))  
  }
  var taxvalue = 0
  for(let i =0; i< taxtotal.length; i++) {
  taxvalue += taxtotal[i]
  }
  localStorage.setItem('taxvalue',taxvalue)
  //AsyncStorage.setItem('Toataltax', taxvalue.toString())
  let  totalnetamount = []
  for(const data of removeproducts) {
    totalnetamount.push(parseFloat(data.Rate * data.Order_Quantity))
  }
  var totalnetcount = 0
  for(let i =0; i< totalnetamount.length; i++) {
    totalnetcount += totalnetamount[i]
  }
  //settotalamt(totalnetcount)
  //AsyncStorage.setItem('Totalamt', totalnetcount.toString())
  //localStorage.setItem('Totalsumamounts',totalnetcount)
  
  
  localStorage.setItem('Totalsumamounts',totalnetcount)
 
  let totalIgstamt = []
  for(const data of removeproducts) {
  totalIgstamt.push(parseFloat((data.Rate * data.Order_Quantity) * data.GSTPer/100))
  ////////////////console.log('igst', data.IGSTPer)
  }
  var  totalIgstvalu = 0
  for(let i=0; i< totalIgstamt.length; i++) {
  totalIgstvalu +=totalIgstamt[i]
  }
  localStorage.setItem('Totaligstvalue',totalIgstvalu)

  ////////////////console.log(totalIgstvalu)
  //settotaltax(totalcgstvalu +totalcgstvalu)
  setTOtaligstamt(totalIgstvalu)
  
  
  //let prodvalues = JSON.parse(Getprod)
  ////////////////console.log(prodvalues)
  //setprovalue(prodvalues)
  ////////////////console.log('updatedata',localStorage.getItem('Carts'))
  setModal(false)

  setdailoa1(true)
  setTimeout(() => {
    setdailoa1(false)
    setprodupdata(true)
  }, 3000);
}else{
  setqtyerror(true)
  setTimeout(() => {
    setqtyerror(false)
  }, 2000);
}
  }
const toggle = () => {
  if (modal) {
    setModal(false)
   // setUser(null)
  
  } else {
    setModal(true)
  }
}

const handleUserClick = (arg,index) => {
  ////////////console.log(arg)

  //setIsEdit(true)
if(props.match.params.id) {
 // Getpurchaseorderdetils()
  setqtyval(arg.Order_Quantity)
  setpricevalue(arg.Rate)
  setpurchsdtlid(arg.PO_Detail_Id)
} else {
  Updateget(arg.Product_Details_Id,index)
  setpricevalue(arg.Rate)

}
// if(!props.match.params.id) {
//   Updatepurchseorderdts()
// } else{

// }
  toggle()
}

const deleteproduct  =  async(id) => {
 
// setdailoa1(true)
 setTimeout(() => {
  setdailoa1(false)

 }, 2000);
 setDeleteModal(true)

  let productsvalue = localStorage.getItem('Carts')
  var items = JSON.parse(productsvalue)
  // ////////////////console.log(items)
  for (var i =0; i< items.length; i++) {
  // var items = JSON.parse(items[i]);
  //////////////////console.log(items[i].Product_Id)
  if (items[i].Product_Details_Id == id) {
   const deletedata =  items.splice(i, 1);
   //////////////////console.log(deletedata)
  }
  
  }
  //////////////////console.log(items)
  let  prod = JSON.stringify(items);
  
  localStorage.setItem('Carts', prod)
  const getdelteddate =  localStorage.getItem('Carts')
  
  let removeproducts = JSON.parse(getdelteddate)

  localStorage.setItem('purchasecart',removeproducts.length)

  setallcartproducts(removeproducts)
  const indexofnum =removeproducts.map((items, index) => ({index, ...items}))
  let qtytotal = []
  
  for(const data of removeproducts){
    qtytotal.push(parseFloat(data.Order_Quantity))

  }
  var qtyvalue = 0 
  for (let i = 0; i < qtytotal.length; i++) {
    qtyvalue += qtytotal[i];
  }

  settotalqty(qtyvalue)
  localStorage.setItem('TotalQty',qtyvalue)
  
  let taxtotal = []
  for(const data of removeproducts) {
  taxtotal.push(parseFloat(data.GSTPer))
  }
  var taxvalue = 0
  for(let i =0; i< taxtotal.length; i++) {
  taxvalue += taxtotal[i]
  }
  localStorage.setItem('taxvalue',taxvalue)
  //AsyncStorage.setItem('Toataltax', taxvalue.toString())
  let  totalnetamount = []
  for(const data of removeproducts) {
    totalnetamount.push(parseFloat(data.Rate * data.Order_Quantity))
  }
  var totalnetcount = 0
  for(let i =0; i< totalnetamount.length; i++) {
    totalnetcount += totalnetamount[i]
  }
  localStorage.setItem('Totalsumamounts',totalnetcount)
 // settotalamt(totalnetcount)
  //AsyncStorage.setItem('Totalamt', totalnetcount.toString())
  
  
  
  let totalIgstamt = []
  for(const data of removeproducts) {
  totalIgstamt.push(parseFloat((data.Rate * data.Order_Quantity) * data.GSTPer/100))
  ////////////////console.log('igst', data.IGSTPer)
  }
  var  totalIgstvalu = 0
  for(let i=0; i< totalIgstamt.length; i++) {
  totalIgstvalu +=totalIgstamt[i]
  }
  

  //////////////console.log(totalIgstvalu)
  //settotaltax(totalcgstvalu +totalcgstvalu)
  setTOtaligstamt(totalIgstvalu)
  localStorage.setItem('Totaligstvalue',totalIgstvalu)
  ////////////////console.log(  

  setDeleteModal(false)
  setdelteprods(true)
  // localStorage.removeItem('purchasecart')
  }
 
const toggledeletemodal  = (id) => {
  setDeleteModal(true)
  setdeletid(id)
 

}
const Getallsuppliervalue = async() => {
  const get= await axios.instance.get(`/Getonepurchasedtl/${props.match.params.id}`,{ headers: {'Authorization':tokent,
  'Content-Type': 'application/json',
  
  }}).then((res) => {
    
  //////////////console.log(res.data)
    setpurchasegetone(res.data)
    var getoneprodctsofpurchse = res.data
   //////////console.log('',getoneprodctsofpurchse)
    localStorage.setItem('Carts',JSON.stringify(getoneprodctsofpurchse))
    for (const data of res.data) {
      setbillraised(data.Billed)
    }
    ////////////console.log(res.data)
    let qtytotal = []
  
    for(const data of res.data){
    qtytotal.push(parseFloat(data.Order_Quantity))
    }
    var qtyvalue = 0 
    for (let i = 0; i < qtytotal.length; i++) {
      qtyvalue += qtytotal[i];
    }
    settotalqty(qtyvalue)
    localStorage.setItem('TotalQty',qtyvalue)
    
    let taxtotal = []
    for(const data of res.data) {
    taxtotal.push(parseFloat(data.GSTPer))  
    }
    var taxvalue = 0
    for(let i =0; i< taxtotal.length; i++) {
    taxvalue += taxtotal[i]
    }
    localStorage.setItem('taxvalue',taxvalue)
    //AsyncStorage.setItem('Toataltax', taxvalue.toString())
    let  totalnetamount = []
    for(const data of res.data) {
      totalnetamount.push(parseFloat(data.Rate * data.Order_Quantity))
    }
    var totalnetcount = 0
    for(let i =0; i< totalnetamount.length; i++) {
      totalnetcount += totalnetamount[i]
    }
    //settotalamt(totalnetcount)
    //AsyncStorage.setItem('Totalamt', totalnetcount.toString())
    //localStorage.setItem('Totalsumamounts',totalnetcount)
    
    
    localStorage.setItem('Totalsumamounts',totalnetcount)
   
    let totalIgstamt = []
    for(const data of res.data) {
    totalIgstamt.push(parseFloat((data.Rate * data.Order_Quantity) * data.GSTPer/100))
    ////////////////console.log('igst', data.IGSTPer)
    }
    var  totalIgstvalu = 0
    for(let i=0; i< totalIgstamt.length; i++) {
    totalIgstvalu +=totalIgstamt[i]
    }
    localStorage.setItem('Totaligstvalue',totalIgstvalu)
  
    ////////////////console.log(totalIgstvalu)
    //settotaltax(totalcgstvalu +totalcgstvalu)
    setTOtaligstamt(totalIgstvalu)
  })
  }


  const Getpurchaseorderdetils = async() => {
    const get= await axios.instance.get(`/Getonepurchasedetails/${props.match.params.id}`,{ headers: {'Authorization':tokent,
    'Content-Type': 'application/json',
    
    }}).then((res) => {
      for(const data of res.data) {
        setqtyval(data.Order_Quantity)
        setpricevalue(data.Rate)
        setpurchsdtlid(data.PO_Detail_Id)
      }
    
      // setpurchasegetone(res.data)
      // let qtytotal = []
    
      // for(const data of res.data){
      // qtytotal.push(parseInt(data.Order_Quantity))
      // }
      // var qtyvalue = 0 
      // for (let i = 0; i < qtytotal.length; i++) {
      //   qtyvalue += qtytotal[i];
      // }
      // settotalqty(qtyvalue)
      // localStorage.setItem('TotalQty',qtyvalue)
      
      // let taxtotal = []
      // for(const data of res.data) {
      // taxtotal.push(parseFloat(data.GSTPer))  
      // }
      // var taxvalue = 0
      // for(let i =0; i< taxtotal.length; i++) {
      // taxvalue += taxtotal[i]
      // }
      // localStorage.setItem('taxvalue',taxvalue)
      // //AsyncStorage.setItem('Toataltax', taxvalue.toString())
      // let  totalnetamount = []
      // for(const data of res.data) {
      //   totalnetamount.push(parseFloat(data.Rate))
      // }
      // var totalnetcount = 0
      // for(let i =0; i< totalnetamount.length; i++) {
      //   totalnetcount += totalnetamount[i]
      // }
      // //settotalamt(totalnetcount)
      // //AsyncStorage.setItem('Totalamt', totalnetcount.toString())
      // //localStorage.setItem('Totalsumamounts',totalnetcount)
      
      
      // localStorage.setItem('Totalsumamounts',totalnetcount)
     
      // let totalIgstamt = []
      // for(const data of res.data) {
      // totalIgstamt.push(parseFloat((data.Rate * data.Order_Quantity) * data.GSTPer/100))
      // ////////////////console.log('igst', data.IGSTPer)
      // }
      // var  totalIgstvalu = 0
      // for(let i=0; i< totalIgstamt.length; i++) {
      // totalIgstvalu +=totalIgstamt[i]
      // }
      // localStorage.setItem('Totaligstvalue',totalIgstvalu)
    
      // ////////////////console.log(totalIgstvalu)
      // //settotaltax(totalcgstvalu +totalcgstvalu)
      // setTOtaligstamt(totalIgstvalu)
    })
    }
    const Updatepurchseorderdts = async() => {
     if(qtyval !=0) {

    
    ////////////console.log("test",purchsdtlid )
  
      const create  = await axios.instance.put(`/Updatepurchaseorderdtl/${purchsdtlid}`, {
   
        Order_Quantity:qtyval,
        Rate:pricevalue,
       
        PriOrder_Quantity:qtyval,
        PriRate:pricevalue,
       
        Act_Rate:pricevalue,
        Act_Qty:qtyval,
    
   
      },{ headers: {'Authorization':tokent,
      'Content-Type': 'application/json',
      
      }}).then((res) => {
        
        ////////////console.log('header', res.data)
        toggle()
        Getallsuppliervalue()
        setprodupdata(true)
        localStorage.getItem('Carts',0)
       })
      }else{
setqtyerror(true) 
setTimeout(() => {
  setqtyerror(false)
}, 2000);
      }
  }
  const roundofnet = Math.round(parseFloat(localStorage.getItem('Totalsumamounts')) + parseFloat(localStorage.getItem('Totaligstvalue')));
  //////////console.log(roundofnet,'round of')
  const roundofcal = parseFloat(roundofnet) -(parseFloat(localStorage.getItem('Totalsumamounts'))+parseFloat(localStorage.getItem('Totaligstvalue')))
 //////////console.log(roundofcal, 'rounde of calculateion',localStorage.getItem('Totalsumamounts'),localStorage.getItem('Totaligstvalue'))
 

  const Updatepurchaseorderhdrs = async() => {
     
    //////////console.log("test",props.match.params.id)
  
      const create  = await axios.instance.put(`/Updatepurchaseorder/${props.match.params.id}`, {
        Total_Amount:parseFloat(localStorage.getItem('Totalsumamounts')) ,

        VAT_Amount:  localStorage.getItem('statecode') === '33' ?  parseFloat(localStorage.getItem('Totaligstvalue'))/2 : 0,
        CST_Amount:0,
        Net_Amount:parseFloat(localStorage.getItem('Totalsumamounts'))+parseFloat(localStorage.getItem('Totaligstvalue')),
        
        IGSTAmt:localStorage.getItem('statecode') === '33' ? 0 : parseFloat(localStorage.getItem('Totaligstvalue')),
        SGSTAmt:localStorage.getItem('statecode') === '33' ?   parseFloat(localStorage.getItem('Totaligstvalue'))/2:0
      //  -- RoundOffAmt:roundofcal
   
      },{ headers: {'Authorization':tokent,
      'Content-Type': 'application/json',
      
      }}).then((res) => {
        
        //////////console.log('header', res.data)
        //toggle()
        Getallsuppliervalue()
        setprodupdata(true)
      localStorage.setItem('Purchaseorderedit','false') 
      })
      
  }
  const Updatepurchaseaddprodut = async() => {
     
    //////////console.log("test",localStorage.getItem('purchseeditid'))
  
      const create  = await axios.instance.put(`/Updatepurchaseorder/${parseInt(localStorage.getItem('purchseeditid'))}`, {
        Total_Amount:parseFloat(localStorage.getItem('Totalsumamounts')) ,

        VAT_Amount:  localStorage.getItem('statecode') === '33' ?  parseFloat(localStorage.getItem('Totaligstvalue'))/2 : 0,
        CST_Amount:0,
        Net_Amount:parseFloat(localStorage.getItem('Totalsumamounts'))+parseFloat(localStorage.getItem('Totaligstvalue')),
        
        IGSTAmt:localStorage.getItem('statecode') === '33' ? 0 : parseFloat(localStorage.getItem('Totaligstvalue')),
        SGSTAmt:localStorage.getItem('statecode') === '33' ?   parseFloat(localStorage.getItem('Totaligstvalue'))/2:0
       
   
      },{ headers: {'Authorization':tokent,
      'Content-Type': 'application/json',
      
      }}).then((res) => {
        
        //////////console.log('header', res.data)
        //toggle()
        //Getallsuppliervalue()
        setprodupdata(true)
        createpursheupdateproduct()
       })
      
  }
  const createpursheupdateproduct = async() => {
     
  
    Deletepurchaseorder()
  
     // setdailoa1(true)
    

    
      const  details = localStorage.getItem('Carts')
      const Orderid =   localStorage.getItem('purchseeditid')
      let product =  JSON.parse(details)
     
      for(const data of product){
        //////////console.log('details',data)
       
        const productcoll = Object.assign({
          PO_Id:localStorage.getItem('purchseeditid'),
          Product_Details_Id:data.Product_Details_Id,
          UOM_Id:data.UOM_Id,
          Order_Quantity:data.Order_Quantity,
          Rate:data.Rate,
          CST_Percentage:0,  
          VAT_Percentage: localStorage.getItem('statecode') === '33' ? data.VAT_Percentage:0,
          Discount_Percentage:0,
          RateinAED:data.Rate,
          TaxId:data.TaxId,
          UOMtype:0,
          DiscAmt:0,
          ExciseId:0,
          ExcisePer:0,  
          OtherDesc:'',
          GSTPer:data.GSTPer,
          SGSTId: localStorage.getItem('statecode') === '33'  ? data.SGSTId :0,
          SGSTPer: localStorage.getItem('statecode') === '33'  ? data.SGSTPer :0,
          IGSTId:localStorage.getItem('statecode') === '33' ? 0: data.IGSTId,
          IGSTPer:localStorage.getItem('statecode') === '33' ? 0:data.IGSTPer,
          PriUOM_Id:data.UOM_Id,
          PriOrder_Quantity:data.Order_Quantity,
          PriRate:data.Rate,
          ConQty:data.Order_Quantity,
          Act_UOM:data.UOM_Id,
          Act_Rate:data.Rate,
          Act_Qty:data.Order_Quantity,
          Sec_UomId:data.UOM_Id
          
          
          },{PO_Id: parseInt(Orderid),OpType:'New'})
    const Dtl  =  await axios.instance.post(`/Insertpurchaseorderdtl`, productcoll
    
    ,{ headers: {'Authorization':tokent,
      'Content-Type': 'application/json',
     
      },method:"post"}).then((res) => {
        //////////console.log( 'details', res.data)

        localStorage.removeItem('TotalQty');
        localStorage.removeItem('taxvalue');
        localStorage.removeItem('Totalsumamounts')
        localStorage.removeItem('Carts')
        localStorage.removeItem('Totaligstvalue')
   
localStorage.removeItem('purchasecart')
localStorage.removeItem('totalsalesrate')

localStorage.setItem('purchasecart',0)
localStorage.removeItem('purchseeditid')
// localStorage.setItem('Carts','')
localStorage.removeItem('Purchaseorderedit')
//SendMail()
    })

    setTimeout(() => {
      setdailoa1(false)
    //  -- setsupperror(false)
    }, 2000);
  
    setPurchasesavess(true)
setTimeout(() => {
  history.push('/Purchaseorder')
  // setsupperror(false)
}, 3000);
  
    }
  
  
  }
  const Deletepurchaseorder = async() => {
    ////////////console.log('testdetel',deletid)
    const createHoliday =  await axios.instance.delete(`/Deletepurchasedtl/${parseInt(localStorage.getItem('purchseeditid'))}`, { headers: {'Authorization':tokent,
    'Content-Type': 'application/json'}}).then((Res) => {
     

      ////////////console.log(Res.data)
     // Getbuyerorders()
      
     
     
      
    })
  }
  return (
    <React.Fragment>
        <DeleteModal
        show={deleteModal}
        onDeleteClick={()=> deleteproduct(deletid)}
        onCloseClick={() => setDeleteModal(false)}
      />
      {props.match.params.id ? (
      <div className="page-content">
        <Container fluid>
          { localStorage.getItem('purchaseviewscreen') === 'Y' ?(
          <Breadcrumbs title="Purchase Order" breadcrumbItem="View Purchase Order" />
          ):  <Breadcrumbs title="Purchase Order" breadcrumbItem="Cart" /> }
{purchasegetone !=null ? (
          <Row className="mb-3">
            <Col xl="8">

              {purchasegetone.map((data, index) => (
                <Card className="border shadow-none" key={data.Product_Details_Id}>
                  <CardBody>
                    <div className="d-flex align-items-start border-bottom pb-3">
                      <div className="flex-shrink1 me-4  hover14 column">
                        <figure>
                      <img src={`${data.Imagepath}`} 
 style={{width:'200px', height:'200px'}}
  alt="" className="img-fluid mx-auto d-block"
  onError={({ currentTarget }) => {
    currentTarget.onerror = null; // prevents looping
    currentTarget.src=imageDefault;
  }}
   
  /> 
  </figure>
                      </div>
                      <div className="flex-grow-1 align-self-center overflow-hidden">
                        <div>
                          <h5 className="text-truncate font-size-16">
                         
                          {data.Product_Details_Description}
                         
                          </h5>
                      
                        </div>
                      </div>
                      <div className="ml-2">
                        <ul className="list-inline mb-0 font-size-16">
                        <li className="list-inline-item">
                            <Link to="#" className="text-muted px-2" onClick={()=>handleUserClick(data,index)}>
                            {billraised && localStorage.getItem('purchaseviewscreen') === 'Y' ? (
                              null
                            ): 
                            <i className="uil uil-pen font-size-16"></i>

                            }
                            </Link>{" "}
                          </li>{" "}
                          {/* <li className="list-inline-item">
                            <Link to="#" className="text-muted px-2" onClick={() => toggledeletemodal(data.Product_Details_Id)}>
                              <i className="uil uil-trash-alt"></i>
                            </Link>{" "}
                          </li>{" "} */}
                          {/* <li className="list-inline-item">
                            <Link to="#" className="text-muted px-2">
                              <i className="uil uil-heart"></i>
                            </Link>
                          </li> */}
                        </ul>
                      </div>
                    </div>
                    <div>
                    <div className="row">
                      <div className="col-md-2">
                        <div className="mt-3">
                          <p className="text-muted mb-2">Price</p>
                          
                          <h5 className="font-size-16">₹ {numeral(data.Rate).format('0,0.00')}  </h5>
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className="mt-3">
                          <p className="text-muted mb-2">Quantity</p>
                          <div
                          
                         
          >
                         {/* /// <Input type="number"  value={qtyval} onChange={(e)=>setqtyval(e.target.value)} /> */}
                          <h5 className="font-size-16">{data.Order_Quantity}</h5>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="mt-3">
                          <p className="text-muted mb-2">Total</p>
                          <h5 className="font-size-16">₹ {numeral(data.Order_Quantity * data.Rate).format('0,0.00') }</h5>
                         
                          </div>
                        </div>
                        <div className="col-md-3">
                        <div className="mt-3">
                          {/* <p className="text-muted mb-2">Quantity</p> */}
                          <div
                          
                         
          >
                        <p className="text-muted mb-2">GST % </p>
                          <h5 className="font-size-16 text-centered">{data.GSTPer}</h5>
                          
                          </div>
                          <div>
                         
                            </div>
                        </div>
                      </div>

                      <div className="col-md-2">
                        <div className="mt-3">
                          {/* <p className="text-muted mb-2">Quantity</p> */}
                          <div
                          
                         
          >
       <p className="text-muted mb-2">GST Amount </p>
                            <h5 className="font-size-16 text-centered">₹ {numeral((data.Order_Quantity * data.Rate * data.GSTPer)/100).format('0,0.00') }</h5>
                          
                          </div>
                          <div>
                         
                            </div>
                        </div>
                      </div>
                    </div>
                    </div>
                  </CardBody>
                </Card>
              ))}
              <Row className="mt-4">
                                    <Col sm={6}>
                                      {billraised && localStorage.getItem('purchaseviewscreen') === 'Y' ? (
                                       null
                                    ):
                                    <Link to="/Purchaseorder" className="btn btn-link text-muted">
                                    <i className="uil uil-arrow-left me-1"></i> Continue Shopping </Link>
                                    }
                                    </Col> 
                                    <Col sm={6}>
                                        <div className="text-sm-end mt-2 mt-sm-0">
                                          {billraised && localStorage.getItem('purchaseviewscreen') === 'Y' ? (
                                          null
                                               ):<Link to="#" className="btn btn-success" onClick={checkoutss1}>
                                               Update </Link> }
                                        </div>
                                    </Col> 
                                </Row>
            </Col>
            <Col xl="4">
              <div className="mt-5 mt-lg-0">
                <Card className="border shadow-none">
                  <div className="card-header bg-transparent border-bottom py-3 px-4">
                  <h5 className="font-size-16 mb-3 text-primary">
                     Price Details <span className="float-end"></span>
                    </h5>
              
                   
                  </div>
                  <CardBody className="p-4">
                    <div className="table-responsive">
                      <Table className="table mb-0">
                        <tbody>
                        <tr>
                            <td> Total Quantity :</td>
                            <td className="text-end">{parseFloat(localStorage.getItem('TotalQty'))}</td>
                          </tr>
                          <tr>
                            <td>Gross Amount :</td>
                            <td className="text-end">₹{numeral(parseFloat(localStorage.getItem('Totalsumamounts'))).format('0,0.00')}</td>
                          </tr>
                        
                       
                      
                          <tr>
                            <td>GST Amount : </td>
                            <td className="text-end"> ₹ {numeral(localStorage.getItem('Totaligstvalue')).format('0,0.00')}</td>
                          </tr>
                          <tr className="bg-light">
                            <th>Total :</th>
                            <td className="text-end">
                            <span className="fw-bold">₹ {numeral(parseFloat(localStorage.getItem('Totalsumamounts'))+parseFloat(localStorage.getItem('Totaligstvalue'))).format('0,0.00') }</span>
                          </td>
                          </tr>
                        </tbody>
                      </Table>
                    </div>
                  </CardBody>
                </Card>
              </div>
            </Col>
          </Row>
          ): 
          
          <div> 
            <h3 className="text-primary text-center"> Your Cart is Empty</h3>
            </div>}
        </Container>
      </div>
      ) :      <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="Purchase Order" breadcrumbItem="Cart" />
{allcartproducts !=null ? (
        <Row className="mb-3">
          <Col xl="8">

            {allcartproducts.map((data, index) => (
              <Card className="border shadow-none" key={data.Product_Details_Id}>
                <CardBody>
                  <div className="d-flex align-items-start border-bottom pb-3">
                    <div className="flex-shrink1 me-4  hover14 column">
                      <figure>
                    <img src={`${data.Imagepath}`} 
style={{width:'200px', height:'200px'}}
alt="" className="img-fluid mx-auto d-block"
onError={({ currentTarget }) => {
  currentTarget.onerror = null; // prevents looping
  currentTarget.src=imageDefault;
}}
 
/>
</figure> 
                    </div>
                    <div className="flex-grow-1 align-self-center overflow-hidden">
                      <div>
                        <h5 className="text-truncate font-size-16">
                       
                            {data.Product_Details_Description}
                       
                        </h5>
                    
                      </div>
                    </div>
                    <div className="ml-2">
                      <ul className="list-inline mb-0 font-size-16">
                      <li className="list-inline-item">
                          <Link to="#" className="text-muted px-2" onClick={()=>handleUserClick(data,index)}>
                          <i className="uil uil-pen font-size-16"></i>
                          </Link>{" "}
                        </li>{" "}
                        <li className="list-inline-item">
                          <Link to="#" className="text-muted px-2" onClick={() => toggledeletemodal(data.Product_Details_Id)}>
                            <i className="uil uil-trash-alt"></i>
                          </Link>{" "}
                        </li>{" "}
                        {/* <li className="list-inline-item">
                          <Link to="#" className="text-muted px-2">
                            <i className="uil uil-heart"></i>
                          </Link>
                        </li> */}
                      </ul>
                    </div>
                  </div>
                  <div>
                    <div className="row">
                      <div className="col-md-2">
                        <div className="mt-3">
                          <p className="text-muted mb-2">Price</p>
                          
                          <h5 className="font-size-16">₹ {numeral(data.Rate).format('0,0.00')}  </h5>
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className="mt-3">
                          <p className="text-muted mb-2">Quantity</p>
                          <div
                          
                         
          >
                         {/* /// <Input type="number"  value={qtyval} onChange={(e)=>setqtyval(e.target.value)} /> */}
                          <h5 className="font-size-16">{data.Order_Quantity}</h5>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="mt-3">
                          <p className="text-muted mb-2">Total</p>
                          <h5 className="font-size-16">₹ {numeral(data.Order_Quantity * data.Rate).format('0,0.00') }</h5>
                         
                          </div>
                        </div>
                        <div className="col-md-3">
                        <div className="mt-3">
                          {/* <p className="text-muted mb-2">Quantity</p> */}
                          <div
                          
                         
          >
                        <p className="text-muted mb-2">GST % </p>
                          <h5 className="font-size-16 text-centered">{data.GSTPer}</h5>
                          
                          </div>
                          <div>
                         
                            </div>
                        </div>
                      </div>

                      <div className="col-md-2">
                        <div className="mt-3">
                          {/* <p className="text-muted mb-2">Quantity</p> */}
                          <div>
       <p className="text-muted mb-2">GST Amount </p>
                            <h5 className="font-size-16 text-centered">₹ {numeral((data.Order_Quantity * data.Rate * data.GSTPer)/100).format('0,0.00') }</h5>
                          
                          </div>
                          <div>
                         
                            </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            ))}
            <Row className="mt-4">
                                  <Col sm={6}>
                                      <Link to="/Purchaseorder" className="btn btn-link text-muted">
                                          <i className="uil uil-arrow-left me-1"></i> Continue Shopping </Link>
                                  </Col> 
                                  <Col sm={6}>
                                    {localStorage.getItem('Purchaseorderedit') === 'true' ? ( 
                                      <div className="text-sm-end mt-2 mt-sm-0">
                                          <Link to="#" className="btn btn-success" onClick={Updatepurchaseaddprodut}>
                                               Update </Link>
                                      </div>
                                      ):  
                                      <div className="text-sm-end mt-2 mt-sm-0">
                                        {localStorage.getItem('purchasecart') === '0' ? (
                                      null
                                ):
                                <Link to="#" className="btn btn-success" onClick={checkoutss}>
                                <i className="uil uil-shopping-cart-alt me-1" ></i> Place Order </Link>
                                }
                                </div> }
                                  </Col> 
                              </Row>
          </Col>
          <Col xl="4">
            <div className="mt-5 mt-lg-0">
              <Card className="border shadow-none">
                <div className="card-header bg-transparent border-bottom py-3 px-4">
                <h5 className="font-size-16 mb-3 text-primary">
                   Price Details <span className="float-end"></span>
                  </h5>
            
                 
                </div>
                <CardBody className="p-4">
                  <div className="table-responsive">
                    <Table className="table mb-0">
                      <tbody>
                      <tr>
                          <td> Total Quantity :</td>
                          <td className="text-end">{localStorage.getItem('TotalQty')}</td>
                        </tr>
                        <tr>
                          <td>Gross Amount :</td>
                          <td className="text-end">₹ {numeral(parseFloat(localStorage.getItem('Totalsumamounts'))).format('0,0.00')}</td>
                        </tr>
                      
                     
                    
                        <tr>
                          <td>GST Amount : </td>
                          <td className="text-end">₹ {numeral(localStorage.getItem('Totaligstvalue')).format('0,0.00')}</td>
                        </tr>
                        <tr className="bg-light">
                          <th>Total :</th>
                          <td className="text-end">
                            <span className="fw-bold"> ₹ {numeral(parseFloat(localStorage.getItem('Totalsumamounts'))+parseFloat(localStorage.getItem('Totaligstvalue'))).format('0,0.00') }</span>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                </CardBody>
              </Card>
            </div>
          </Col>
        </Row>
        ): 
        
        <div> 
          <h3 className="text-primary text-center"> Your Cart is Empty</h3>
          </div>}
      </Container>
    </div> } {props.match.params.id   ? (
      <Modal isOpen={modal} toggle={toggle} size="sm">
            <ModalHeader toggle={toggle} tag="h4">
            { "Update  Product"}
            </ModalHeader>
            <ModalBody>
              <Form
              
              >
                <Row>
                                <Col lg="6">
                                  <div className="mb-3">
                                    <Label for="basicpill-firstname-input1">
                                      Price
                                </Label>
                                <Input
                                type="number"
                                name="Date"
                              value={pricevalue}

                          
                              onChange={(e)=>
                                {
                                  if(e.target.value.length<=7) {
                                    setpricevalue(e.target.value)}
                                  }}
                                  
                              
                              
                              />
                  
                             
                                  </div>
                                </Col>
                                <Col lg="6">
                                  <div className="mb-3">
                                    <Label for="basicpill-firstname-input1">
                                      Quantity
                                </Label>
                                <Input
                                type="number"
                                name="Order_Quantity"
                              value={qtyval}
                             
                              onChange={(e)=>
                                {
                                  if(e.target.value.length <=6) {
                                    setqtyval(e.target.value)}
                                  }
                                                            
                                }/>
                                                                                      {qtyerror ? <p style={{fontSize:"12px"}}  className="error">Please Enter Valid Quantity </p> :  null}

                                  </div>
                                </Col>
                              </Row>
                <Row>
                  <Col>
                     <div className="text-end">
                       {!props.match.params.id ? (
                      <button
                        type="submit"
                        className="btn btn-success save-user"
                   
onClick={(e)=> {
  e.preventDefault()
  updateproduct()
}}
                      
                        
                      >
                        Update
                      </button>
                      ):    
                        <button
                          type="submit"
                          className="btn btn-success save-user"
                          onClick={(e)=> {
                            e.preventDefault()
                            Updatepurchseorderdts()
                          }}      
                        >
                          Update
                        </button>}
                    </div>
                  
               
                  </Col>
                </Row>
              </Form>
            </ModalBody>
          </Modal>
          ):   <Modal isOpen={modal} toggle={toggle} size="sm">
          <ModalHeader toggle={toggle} tag="h4">
          { "Update  Product"}
          </ModalHeader>
          <ModalBody>
            <Form
            
            >
              <Row>
                              <Col lg="6">
                                <div className="mb-3">
                                  <Label for="basicpill-firstname-input1">
                                    Price
                              </Label>
                              <Input
                              type="number"
                              name="Date"
                            value={pricevalue}

                            onChange={(e)=> {
                              
                                if(e.target.value.length<=7) {
                                  setpricevalue(e.target.value)}
                                }}
                           
                            />
                
                           
                                </div>
                              </Col>
                              <Col lg="6">
                                <div className="mb-3">
                                  <Label for="basicpill-firstname-input1">
                                    Quantity
                              </Label>
                              <Input
                              type="number"
                              name="Order_Quantity"
                            value={qtyval}
                            maxLength="11"
                            onChange={(e)=> {
                              if(e.target.value.length<=6) {
                                setqtyval(e.target.value)
                              }}   }                           
                            />
                                                                                                      {qtyerror ? <p style={{fontSize:"12px"}}  className="error">Please Enter Valid Quantity </p> :  null}

                                </div>
                              </Col>
                            </Row>
              <Row>
                <Col>
                   <div className="text-end">
                    <button
                      type="submit"
                      className="btn btn-success save-user"
                 
onClick={(e)=> {
e.preventDefault()
updateproduct()
}}
                    
                      
                    >
                      Update
                    </button>
                  </div>
                
             
                </Col>
              </Row>
            </Form>
          </ModalBody>
        </Modal>}
      {dailoa1 ? (
      <Backdrop  open={dailoa1} className={classes.backdrop} >
      <Spinner name="ball-spin-fade-loader"  color='#fafafa' />

     </Backdrop>
      ): null}
      {Purchasesavess ? (
                    <SweetAlert
                      title="Purchase Order Added Successfully"
                      timeout={2000}
                      style={{
                        position: "absolute",
                         justifyContent:'center',
                         alignItems:'center'
                      }}
                      showCloseButton={false}
                      showConfirm={false}
                      success
                      onConfirm={() => {
                        setPurchasesavess(false);
                      }}
                    ></SweetAlert>
                  ) : null}
 {produpdata ? (
                    <SweetAlert
                      title="Product Updated  Successfully"
                      timeout={2000}
                      style={{
                        position: "absolute",
                         justifyContent:'center',
                         alignItems:'center'
                      }}
                      showCloseButton={false}
                      showConfirm={false}
                      success
                      onConfirm={() => {
                        setprodupdata(false);
                      }}
                    ></SweetAlert>
                  ) : null}


{purchaseupdatesmessage ? (
                    <SweetAlert
                      title="PurchaseOrder Updated  Successfully"
                      timeout={2000}
                      style={{
                        position: "absolute",
                         justifyContent:'center',
                         alignItems:'center'
                      }}
                      showCloseButton={false}
                      showConfirm={false}
                      success
                      onConfirm={() => {
                        setpurchaseupdatesmessage(false);
                      }}
                    ></SweetAlert>
                  ) : null}

{ delteprods? (
                    <SweetAlert
                      title="Product Deleted  Successfully "
                      timeout={2000}
                      style={{
                        position: "absolute",
                         justifyContent:'center',
                         alignItems:'center'
                      }}
                      showCloseButton={false}
                      showConfirm={false}
                      success
                      onConfirm={() => {
                        setdelteprods(false);
                      }}
                    ></SweetAlert>
                  ) : null}
    </React.Fragment>
  );
};

export default EcommerceCart;
